var React = require('react');

function MobileHeaderClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"x","opacity":"0.5"},React.createElement("path",{"id":"Union","fillRule":"evenodd","clipRule":"evenodd","d":"M11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L20 18.5858L27.2929 11.2929C27.6834 10.9024 28.3166 10.9024 28.7071 11.2929C29.0976 11.6834 29.0976 12.3166 28.7071 12.7071L21.4142 20L28.7071 27.2929C29.0976 27.6834 29.0976 28.3166 28.7071 28.7071C28.3166 29.0976 27.6834 29.0976 27.2929 28.7071L20 21.4142L12.7071 28.7071C12.3166 29.0976 11.6834 29.0976 11.2929 28.7071C10.9024 28.3166 10.9024 27.6834 11.2929 27.2929L18.5858 20L11.2929 12.7071Z","fill":"#B6BDD0"})));
}

MobileHeaderClose.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = MobileHeaderClose;

MobileHeaderClose.default = MobileHeaderClose;
